'use client';

import MarketplaceSidebar from '@/components/common/navigation/sidebar/marketplace-sidebar';
import ProfileSidebar from '@/components/common/navigation/sidebar/profile-sidebar';
import { ChatListSidebar } from '@/components/features/chat';
import AIToolsSidebar from '@/components/features/documents/Sidebar';
import { useSidebar } from '@/context/sidebar-context';
import ROUTES from '@/lib/constants/routeConfig';
import { AnimatePresence, motion } from 'framer-motion';
import { usePathname } from 'next/navigation';
import ChatSidebar from './chat-sidebar';

const sidebarRoutes = [
  {
    path: ROUTES.DASHBOARD.ROOT,
    component: ChatSidebar,
  },
  {
    path: ROUTES.DASHBOARD.PROFILE,
    component: ProfileSidebar,
  },
  {
    path: ROUTES.MARKETPLACE.PROFILE,
    component: ProfileSidebar,
  },
  {
    path: ROUTES.HOME,
    component: ChatListSidebar,
  },
  {
    path: ROUTES.USERPROFILE,
    component: MarketplaceSidebar,
  },
  {
    path: ROUTES.MARKETPLACE.ROOT,
    component: MarketplaceSidebar,
  },
  {
    path: ROUTES.AI_TOOLS.MY_DOCUMENTS,
    component: AIToolsSidebar,
  },
  {
    path: ROUTES.AI_TOOLS.DASHBOARD,
    component: AIToolsSidebar,
  },
  {
    path: ROUTES.AI_TOOLS.LEGAL_FORMS.CHOICE,
    component: AIToolsSidebar,
  },
  {
    path: ROUTES.AI_TOOLS.LEGAL_FORMS.LIBRARY,
    component: AIToolsSidebar,
  },
  {
    path: ROUTES.AI_TOOLS.LEGAL_FORMS.FIND_FORM,
    component: AIToolsSidebar,
  },
  {
    path: ROUTES.AI_TOOLS.FORMAL_NOTICE,
    component: AIToolsSidebar,
  },
  {
    path: ROUTES.AI_TOOLS.CASE_LAW,
    component: AIToolsSidebar,
  },
  {
    path: ROUTES.AI_TOOLS.CASE_LAW_SEARCH,
    component: AIToolsSidebar,
  },
  {
    path: ROUTES.DASHBOARD.CONVERSATIONS,
    component: ChatSidebar,
  },
  {
    path: ROUTES.MARKETPLACE.CONVERSATIONS,
    component: ChatSidebar,
  },
];

export function AnimatedSidebar() {
  const { isSidebarOpen, isMobile } = useSidebar();
  const pathname = usePathname();

  // Find the matching sidebar component - use exact match first
  // let SidebarComponent = sidebarRoutes.find(
  //   (route) => route.path === pathname
  // )?.component;

  let SidebarComponent = sidebarRoutes
    .sort((a, b) => b.path.length - a.path.length)
    .find(
      (route) =>
        pathname === route.path || pathname.startsWith(`${route.path}/`)
    )?.component;

  return (
    <AnimatePresence initial={false}>
      {isSidebarOpen && (
        <motion.div
          initial={{ x: isMobile ? '-100%' : 0 }}
          animate={{ x: 0 }}
          exit={{ x: isMobile ? '-100%' : 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          className={`fixed left-0 top-[72px] z-10 h-[calc(100vh-72px)] ${
            isMobile ? 'w-full' : 'w-80'
          }`}
        >
          {SidebarComponent && <SidebarComponent />}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
